import { FieldValidationConstraints } from "./ValidationInterfaces";
import { Utility } from "./Utility";
import { EntityField } from "./genericdocuments/EntityField";
import { validate as validateFromValidateJs, validators } from "validate.js";

//@ts-ignore
validators.ipAddressList = (value, options, key, attributes) => {
	if (value === "*") {
		return null;
	}
	const regex = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(,(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))*$/g;
	if (regex.test(value)) {
		return null;
	}
	return "must be valid IP address list";
};

const createValidateJsConstraint = (c: FieldValidationConstraints): any => {
	const res: any = {};

	// If validator is not defined, do not validate anything
	if (!c) {
		return res;
	}

	// Required
	if (c.required) {
		res.presence = {
			allowEmpty: false,
			message: "Obavezno polje"
		};
	}

	// Email
	if (c.email) {
		res.email = {
			message: "Validan email"
		};
	}

	// URL
	if (c.url) {
		res.url = {
			message: "Validan url"
		};
	}

	// Length
	const { lengthMin, lengthMax } = c;
	if (lengthMin != null || lengthMax != null) {
		const lengthObj: any = {};
		if (lengthMin != null) {
			lengthObj.minimum = lengthMin;
			lengthObj.tooShort = `Minimalna dužina je ${lengthMin}`
		}
		if (lengthMax != null) {
			lengthObj.maximum = lengthMax;
			lengthObj.tooLong = `Maksimalna dužina je ${lengthMax}`
		}
		res.length = lengthObj;
	}

	// Numbers
	const { isNumber, isInteger, isPositiveOrZero, isPositive, lessThan, lessThanOrEqualTo, greaterThan, greaterThanOrEqualTo } = c;
	if (isNumber || isInteger) {
		const numericality: any = {
			noStrings: false,
			notValid: "Morate uneti broj"
		};
		if (isInteger) {
			numericality.onlyInteger = true;
			numericality.notInteger = "Morate uneti celobrojnu vrednost"
		}
		if (isPositiveOrZero) {
			numericality.greaterThanOrEqualTo = 0;
			numericality.notGreaterThanOrEqualTo = "Morate uneti prirodan broj"
		}
		if (isPositive) {
			numericality.greaterThan = 0;
			numericality.notGreaterThan = "Morate uneti pozitivan broj"
		}
		if (lessThan != null) {
			numericality.lessThan = lessThan;
			numericality.notLessThan = `Morate uneti broj manji od ${lessThan}`
		}
		if (lessThanOrEqualTo != null) {
			numericality.lessThanOrEqualTo = lessThanOrEqualTo;
			numericality.notLessThanOrEqualTo = `Morate uneti broj manji ili jednak ${lessThanOrEqualTo}`
		}
		if (greaterThan != null) {
			numericality.greaterThan = greaterThan;
			numericality.notGreaterThan = `Morate uneti broj veći od ${greaterThan}`
		}
		if (greaterThanOrEqualTo != null) {
			numericality.greaterThanOrEqualTo = greaterThanOrEqualTo;
			numericality.notGreaterThanOrEqualTo = `Morate uneti broj veći ili jedna ${greaterThan}`
		}
		res.numericality = numericality;
	}
	res.ipAddressList = c.ipAddressList;
	return res;
};

export const validate = (formState: any, entityFields: EntityField[]) => {
	if (!entityFields || entityFields.length === 0) {
		return undefined;
	}
	const constraints = Utility.reduce(entityFields, (acc: any, item: EntityField) => {
		const { validator } = item;
		const validatorObject = Utility.isFunction(validator) ? validator(formState) : validator;
		acc[item.name] = createValidateJsConstraint(validatorObject);
		return acc;
	}, {});
	console.error("Form state and constraints", formState, constraints);
	const validationState = validateFromValidateJs(formState, constraints);
	console.error("Validation state", validationState);
	return validationState;
}
